<div class="row">
  <nav class="navbar navbar-fixed-top {{app.enviro === 'dev' ? ' environment-dev' : ''}}" role="navigation" style="margin-bottom: 0">
    <div class="navbar-header">
      <div class="page-title" (click)="toggleNavigation()">
        <h1>{{ app.appInfo.title }}</h1>
      </div>
      @if (app.appInfo.versionWarning) {
        <div class="navbar-warning">
          <i class="fa fa-warning ms-2" title="{{app.appInfo.versionWarning}}"></i>
        </div>
      }
    </div>
    <ul class="nav navbar-top-links navbar-right d-none d-sm-block">
      <li style="margin: 0px; margin-right: 15px;">
        <a [routerLink]="''" style="padding: 0;"> <img src="./assets/images/logo.png" style="height: 50px; width: 100%;" /> </a>
      </li>
    </ul>
  </nav>
</div>
